// extracted by mini-css-extract-plugin
export default {"body":"IntegrationModal_body__yMBE7","footer":"IntegrationModal_footer__sREMS"};